import { defineMessages } from 'react-intl';

const messages = defineMessages({
  signOut: {
    id: 'baseLayout.signOut',
    defaultMessage: 'Log out',
  },
  profile: {
    id: 'baseLayout.profile',
    defaultMessage: 'Profile',
  },
  collectionStatus: {
    id: 'baseLayout.collectionStatus',
    defaultMessage: 'Collection status',
  },
});

export default messages;
